import { plainToInstance, Type } from 'class-transformer'
import { Node } from 'rete'
import i18n from 'vue-i18n'

import { BaseFlowButtonWithOutput } from '../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/ButtonsConstructor/Buttons/FlowButtons/BaseFlowButtonWithOutput'
import MessageEditorWithMediaData from '../../../../../../../NewMessageEditors/NewMessageEditorWithMedia/types'
import { MenuSectionNames } from '../../../../../components'
import CustomEditor from '../../../../Editor/CustomEditor'
import { BaseNodeModelData } from '../../../BaseNode/BaseNodeDataModel'
import { BaseNodeModel } from '../../../BaseNode/BaseNodeModel'
import { CustomNode, CustomNodeComponent, NodeTypes } from '../../../index'
import SampleEditLastMessageNode from '../ui/SampleNode/SampleEditLastMessageNode.vue'
import EditLastMessageSidebar from '../ui/Sidebar/EditLastMessageSidebar.vue'
import { EditLastMessageNodeProps } from './types'

export default class EditLastMessageNodeBuilder extends CustomNodeComponent {
  menuSection = MenuSectionNames.Communications
  sidebarComponent = EditLastMessageSidebar

  constructor(i18n: i18n, nodeProps: EditLastMessageNodeProps) {
    super(SampleEditLastMessageNode, EditLastMessageNode, NodeTypes.EditLastMessage, i18n, nodeProps)
  }

  getBaseNodeModel = ([ x, y ]: [number, number]) => {
    return {
      data: plainToInstance(EditLastMessageNodeData, {
        type: NodeTypes.EditLastMessage,
        variants: []
      }),
      output: CustomNode.LastSocketId += 1,
      input: CustomNode.LastSocketId += 1,
      color: null,
      x,
      y,
    }
  }
}

export class EditLastMessageNode extends CustomNode {
  data: EditLastMessageNodeData

  declare nodeProps: EditLastMessageNodeProps

  constructor(name: NodeTypes.EditLastMessage, model: BaseNodeModel, nodeProps: EditLastMessageNodeProps) {
    super(name, model, nodeProps)

    if (model.data instanceof EditLastMessageNodeData) {
      this.data = model.data

      model.data.variants[0]?.buttons.forEach((r) => r.forEach((b) => {
        if (b instanceof BaseFlowButtonWithOutput && b.output) {
          this.socketActions.createOutput(b.output)
        }
      }))
    } else {
      throw new Error('To node come unknown data')
    }
  }

  async changeMessages(messages: Array<MessageEditorWithMediaData>, editor: CustomEditor): Promise<void> {
    const availableButtons: Array<BaseFlowButtonWithOutput> = []
    const movedSockets: Array<number> = []

    this.data.variants[0]?.buttons.forEach((r) => r.forEach((b) => {
      if (b instanceof BaseFlowButtonWithOutput) {
        availableButtons.push(b)
      }
    }))

    messages[0]?.buttons.forEach((r) => r.forEach((b) => {
      if (b instanceof BaseFlowButtonWithOutput) {
        const isExistButton = availableButtons.find((ab) => ab.guid === b.guid )

        if (isExistButton && isExistButton.output) {
          b.output = isExistButton.output

          availableButtons.splice(availableButtons.indexOf(isExistButton), 1)

          this.socketActions.switchIsMoved(b.output, true)
          movedSockets.push(b.output)
        } else {
          b.output = this.socketActions.createOutput()
        }
      }
    }))

    this.data.variants = messages

    requestAnimationFrame(() => movedSockets.forEach((id) => this.socketActions.switchIsMoved(id, false)))

    requestAnimationFrame(() => {
      availableButtons.forEach((b) => {
        if (b.output) {
          this.socketActions.deleteOutput(b.output)
        }
      })
    })

    await this.update()
    editor.view.updateConnections({ node: this as unknown as Node })
  }
}

export class EditLastMessageNodeData extends BaseNodeModelData {
  declare type: NodeTypes.EditLastMessage

  @Type(() => MessageEditorWithMediaData)
  variants!: Array<MessageEditorWithMediaData>
}
